import { motion } from "framer-motion";
import { KeyRound, Sparkles, Undo2, ArrowRight } from "lucide-react";
import { PICKUP_AREAS, BIZ } from "@/data/business";
import { MaskLines, Reveal, EASE } from "./motion";
import { scrollToId } from "./SmoothScroll";

const STEPS = [
  { i: KeyRound, t: "We pick up", d: "From your home or work." },
  { i: Sparkles, t: "We detail", d: "In our Vernon shop." },
  { i: Undo2, t: "We return", d: "Back to you, finished." },
];

export const Pickup = ({ onPick }) => (
  <section id="pickup" data-testid="pickup-section" className="relative overflow-hidden bg-[#1bb4f2] text-[#07080B]">
    <div className="absolute -right-24 -top-24 h-[420px] w-[420px] rounded-full border-[60px] border-[#07080B]/10" />
    <div className="relative mx-auto max-w-[1440px] px-5 md:px-10 py-20 md:py-28 grid lg:grid-cols-12 gap-12 items-end">
      <div className="lg:col-span-7 min-w-0">
        <Reveal><p className="font-mono text-xs uppercase tracking-[0.28em] mb-6">Pickup & drop-off available</p></Reveal>
        <h2 className="font-display font-black uppercase leading-[0.9] tracking-tight text-[6.6vw] sm:text-[2.6rem] md:text-5xl lg:text-[3.3rem] xl:text-[3.9rem]">
          <MaskLines lines={["Your car detailed.", "Your day"]} inView />
          <MaskLines lines={["uninterrupted."]} inView lineClass="text-white" delay={0.24} />
        </h2>
        <Reveal delay={0.2}>
          <div className="mt-8 flex flex-wrap gap-2" data-testid="pickup-areas">
            {PICKUP_AREAS.map((a) => <span key={a} className="px-4 py-2 bg-[#07080B] text-white font-semibold text-sm">{a}</span>)}
          </div>
          <p className="mt-4 text-sm font-medium max-w-md">Or we can arrange a ride home or to work while we detail.</p>
        </Reveal>
      </div>
      <div className="lg:col-span-5 min-w-0">
        <div className="grid gap-px bg-[#07080B]/15 border border-[#07080B]/15">
          {STEPS.map((s, k) => (
            <motion.div key={s.t} initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.8, ease: EASE, delay: k * 0.1 }} className="flex items-center gap-5 bg-[#1bb4f2] p-5 md:p-6">
              <span className="h-12 w-12 shrink-0 grid place-items-center bg-[#07080B] text-[#1bb4f2]"><s.i className="h-5 w-5" /></span>
              <div><p className="font-display font-black uppercase text-lg">{s.t}</p><p className="text-sm">{s.d}</p></div>
            </motion.div>
          ))}
        </div>
        <div className="mt-4 flex flex-wrap gap-3">
          <button onClick={() => { onPick(); scrollToId("quote"); }} data-testid="pickup-book-button" className="group inline-flex items-center gap-3 h-14 px-6 bg-[#07080B] text-white font-semibold hover:bg-white hover:text-[#07080B] transition-colors">
            Book a pickup <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </button>
          <a href={BIZ.sms} data-testid="pickup-text-button" className="inline-flex items-center h-14 px-6 border border-[#07080B] font-semibold hover:bg-[#07080B] hover:text-white transition-colors">Text {BIZ.phone}</a>
        </div>
      </div>
    </div>
  </section>
);
